export default "__VITE_PUBLIC_ASSET__73e6fd51__"